export default function(state = null, action) {
	switch(action.type) {
		case 'FETCH_ACCOUNT':
			return { ...state, ...action.payload.data[0] }
		case 'UPDATE_ACCOUNT':
			return { ...state, status: action.payload }
		default:
			return state;
	}
}